import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIleggelseKlagebehandlingVedtak } from "../../../../actions/ileggelserActions";
import Klagebehandlinginformasjon from "../../Detalj/Klagebehandlinginformasjon";

export default function KlagebehandlingInformasjonContainer({ ileggelseId }) {
  const ileggelseKlagebehandlingVedtak = useSelector(
    (state) => state.ileggelseKlagebehandlingVedtak,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (ileggelseId) dispatch(getIleggelseKlagebehandlingVedtak(ileggelseId));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <Klagebehandlinginformasjon vedtak={ileggelseKlagebehandlingVedtak} />;
}

KlagebehandlingInformasjonContainer.propTypes = {
  ileggelseId: PropTypes.string,
};
